import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import { connect } from 'react-redux';
import { selectCardsLibraryMeta } from './selectors';
import {
  selectAgeRangeOptions,
  selectSkillsOptions,
} from 'selectors';
import { updateCardsFilters } from './actions';
import { loadDashboardFilters } from 'actions/partner';

import Select from 'react-select-legacy';
import EditSearch from 'components/filters/EditSearch';


class CardsLibraryFilters extends React.Component {
  constructor(props) {
    super(props);

    this.handleNameSearchQueryChange = this.handleNameSearchQueryChange.bind(this);
    this.handleAgeRangeChange = this.handleAgeRangeChange.bind(this);
    this.handleSkillChange = this.handleSkillChange.bind(this);
  }

  componentDidMount() {
    this.props.loadDashboardFilters();
  }

  render() {
    return (
      <div className='row u-margin-top--base u-margin-bottom--large'>
        <div className='column small-12 medium-4 large-3'>
          { this.renderAgeRangesSelect() }
        </div>
        <div className='column small-12 medium-4 large-3'>
          { this.renderSkillsSelect() }
        </div>
        <div className='column small-12 medium-4 large-3'>
          { this.renderNameSearch() }
        </div>
      </div>
    );
  }

  renderAgeRangesSelect() {
    const { ageRangeOptions } = this.props;
    const { ageRange } = this.props.meta;

    return (
      <Select
        options={ageRangeOptions}
        value={ageRange}
        onChange={this.handleAgeRangeChange}
        className={'o-select'}
        placeholder={this.props.t('library.cards.ageRangePlaceholder')}
        disabled={this.props.isLoading}
      />
    );
  }

  handleAgeRangeChange(ageRange) {
    this.props.updateCardsFilters({
      ageRange: ageRange && ageRange.value,
    });
  }

  renderSkillsSelect() {
    const { skillsOptions } = this.props;
    const { skill } = this.props.meta;

    return (
      <Select
        options={skillsOptions}
        value={skill}
        onChange={this.handleSkillChange}
        className={'o-select'}
        placeholder={this.props.t('library.cards.skillPlaceholder')}
        disabled={this.props.isLoading}
      />
    );
  }

  handleSkillChange(skill) {
    this.props.updateCardsFilters({
      skill: skill && skill.value,
    });
  }

  renderNameSearch() {
    const { q } = this.props.meta;

    return (
      <EditSearch
        placeholder={this.props.t('library.cards.searchPlaceholder')}
        value={q}
        onChange={this.handleNameSearchQueryChange}
        disabled={this.props.isLoading}
      />
    );
  }

  handleNameSearchQueryChange(query) {
    this.props.updateCardsFilters({
      q: query,
    });
  }

}


const mapStateToProps = (state) => {
  return {
    meta: selectCardsLibraryMeta(state),
    ageRangeOptions: selectAgeRangeOptions(state),
    skillsOptions: selectSkillsOptions(state),
  };
};

const mapDispatchToProps = {
  loadDashboardFilters,
  updateCardsFilters,
};

CardsLibraryFilters.propTypes = {
  meta: PropTypes.object.isRequired,
  loadDashboardFilters: PropTypes.func.isRequired,
  updateCardsFilters: PropTypes.func.isRequired,
  ageRangeOptions: PropTypes.array.isRequired,
  skillsOptions: PropTypes.array.isRequired,
  isLoading: PropTypes.bool.isRequired,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation()(CardsLibraryFilters));
